'use strict';


import fs from "fs";
import path from "path";
fs.renameSync(
    path.join(process.cwd(), "./lib/need_copy/api/controllers/FlowController.js"),
    path.join(process.cwd(), "../../api/controllers/FlowController.js"));
fs.renameSync(
    path.join(process.cwd(), "./lib/need_copy/api/routes/flow.js"),
    path.join(process.cwd(), "../../api/routes/flow.js"));
if (!fs.existsSync(path.join(process.cwd(), "../../views/flow"))) {
    fs.mkdirSync(path.join(process.cwd(), "../../views/flow"))
}
fs.renameSync(
    path.join(process.cwd(), "./src/need_copy/views/flow/doFlow-1.ejs"),
    path.join(process.cwd(), "../../views/flow/doFlow-1.ejs"));
fs.renameSync(
    path.join(process.cwd(), "./src/need_copy/views/flow/doFlow-2.ejs"),
    path.join(process.cwd(), "../../views/flow/doFlow-2.ejs"));